import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { Box, CircularProgress, Typography } from '@mui/material';

// Initialize Stripe with publishable key from environment variable
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    'pk_test_51R4b92JQR9jqH5bvKK3gs8bXcQvMjB2MNcynZV7mwxJ86QUT5juXKkuJZNoqP6CbUkZizcz5JwQgqkecsTHnep3e00flEChh5Q'
);

const StripeCheckout = ({ clientSecret, onClose, onPaymentSuccess }) => {
  if (!clientSecret) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
      onClick={(e) => {
        // Close if clicking outside the checkout form
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 600,
          maxHeight: '90vh',
          overflowY: 'auto',
          backgroundColor: '#fff',
          borderRadius: 2,
          p: 0,
          position: 'relative',
        }}
      >
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret, onComplete: onPaymentSuccess }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Box>
    </Box>
  );
};

export default StripeCheckout;
